import { ChargeDisplayInterface } from '../../pages/components/PaymentDataContent/PaymentDataContent';

export function getTotalForCharges(
  charges: ChargeDisplayInterface[],
  {
    includeDiscounts,
    includeTaxes,
  }: {
    includeDiscounts: boolean;
    includeTaxes: boolean;
  },
): number {
  return charges.reduce((acc, charge) => {
    acc += Number(charge.amountBaseValue);

    if (includeDiscounts) {
      acc -=
        charge.appliedDiscounts?.reduce(
          (acc, discount) => acc + Number(discount.amountValue),
          0,
        ) ?? 0;
    }
    if (includeTaxes) {
      acc +=
        charge.taxes?.reduce((acc, tax) => acc + Number(tax.amountValue), 0) ??
        0;
    }
    return acc;
  }, 0);
}
